import { useFeatureFlag } from '@order/LaunchDarkly';

export const useIsChatAppEnabled = () => {
  const isKustomerEnabled = useFeatureFlag('OPS-kustomer-enabled');
  const isSierraEnabled = useFeatureFlag('permanent-sierra-enabled');

  return isKustomerEnabled || isSierraEnabled;
};
